export default {
  path: "/upcoming",
  name: "upcoming",
  component: () => import("@/views/Page.vue"),
  children: [
    {
      path: "/upcoming/index",
      name: "upcomingIndex",
      component: () => import("@/components/approval/completed.vue"),
      meta: {
        title: "我的申请"
      }
    },
    {
      path: "/upcoming/record",
      name: "record",
      component: () => import("@/components/approval/record.vue"),
      meta: {
        title: "审批记录"
      }
    },
    {
      path: "/approvaling",
      name: "approvaling",
      component: () => import("@/components/approval/upComDetail.vue"),
      meta: {
        title: "审批详情"
      }
    },
    {
      path: "/approval/detailList",
      name: "approvalDetailList",
      component: () => import("@/components/approval/detailList.vue"),
      meta: {
        title: "休假明细"
      }
    },
    // 考勤异常明细
    {
      path: "/approval/attendanceList",
      name: "abnormalAttendanceList",
      component: () => import("@/components/approval/attendanceList.vue"),
      meta: {
        title: "考勤异常明细"
      }
    },
    {
      path: "/approval/fileList",
      name: "approvalFileList",
      component: () => import("@/components/approval/fileList.vue"),
      meta: {
        title: "附件列表"
      }
    },
    {
      path: "/approval/test",
      name: "approvalTest",
      component: () => import("@/components/approval/test.vue"),
      meta: {
        title: "测试"
      }
    },
    {
      path: "/approval/legalOvertimeList",
      name: "legalOvertimeList",
      component: () => import("@/components/approval/overtimeList.vue"),
      meta: {
        title: "法定加班申请明细"
      }
    }
  ]
};
